module.exports = __webpack_public_path__ + "static/Masoom_Haider_headshot_lores-3f6d59801fe8a861f6398cd78968bd11.png";